import { Button } from "@progress/kendo-react-buttons";
import { Badge } from "@progress/kendo-react-indicators";
import { formatCurrency, formatDate } from "../../utils/formatters";
import { getOptionLabel } from "../../utils/i18n";

const priorityTone = {
  Low: "success",
  Medium: "info",
  High: "warning",
  Critical: "error"
};

export default function ExpenseMobileCards({ currencyCode, expenses, locale, onDelete, onEdit }) {
  const optionLabel = (group, value, fallback = value) => getOptionLabel(locale, group, value, fallback);

  return (
    <div className="expense-mobile-list">
      {expenses.map((expense) => (
        <article className="expense-mobile-card" key={expense.id}>
          <div className="expense-mobile-topline">
            <div>
              <strong>{expense.title}</strong>
              <span>{formatDate(expense.date, locale?.localeCode)}</span>
            </div>
            <em>{formatCurrency(expense.amountConverted, currencyCode, locale?.localeCode)}</em>
          </div>
          <div className="expense-mobile-meta">
            <Badge themeColor="primary" shape="rounded">
              {optionLabel("categories", expense.category)}
            </Badge>
            <Badge themeColor={priorityTone[expense.priority] || "info"} shape="rounded">
              {optionLabel("priorities", expense.priority)}
            </Badge>
            <span>
              {expense.parentRecurringId
                ? locale?.common?.generated || "Generated"
                : optionLabel("frequencies", expense.frequency)}
            </span>
          </div>
          <div className="expense-mobile-actions">
            <Button fillMode="outline" icon="edit" onClick={() => onEdit(expense)}>
              {locale?.common?.edit || "Edit"}
            </Button>
            <Button fillMode="outline" themeColor="error" icon="delete" onClick={() => onDelete(expense.id)}>
              {locale?.common?.delete || "Delete"}
            </Button>
          </div>
        </article>
      ))}
    </div>
  );
}
